(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('downloadIndicator', ['$window', '$timeout', function ($window, $timeout) {
    return {
      restrict: 'A',
      scope: {
        subDetail: '='
      },
      link: function link(scope, elem, attrs) {
        var loading = false;
        elem.addClass('transform-origin-center');
        if (scope.subDetail.href.indexOf('/activity/csv') === -1) {
          elem.on('click', function () {
            var reset = applyLoadingState(elem, attrs);
            if (!loading) {
              loading = true;
              $window.location = scope.subDetail.href;
              $timeout(function () {
                loading = false;
                reset();
              }, 10 * 1000);
            }
          });
        }
        function applyLoadingState(elem, attrs) {
          var originalTooltip = scope.subDetail.tooltip;
          var originalXLinkHref = attrs.xlinkHref;
          elem.addClass('fa-spin');
          attrs.$set('xlinkHref', '#circle-notch');
          scope.subDetail.tooltip = "Download file generating";
          return function reset() {
            elem.removeClass('fa-spin');
            attrs.$set('xlinkHref', originalXLinkHref);
            scope.subDetail.tooltip = originalTooltip;
          };
        }
      }
    };
  }]);
})();
